// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"8252ba78160b233c","916":"c17338a064414f57"}[chunkId] + ".js";
};